import React, {Component} from 'react'
import {withTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import _ from 'lodash';

// Decorate the class.
@withTranslation()
@connect(
	state => ({ // mapStateToProps
		residentialAreas: state.residentialArea.all
	})
)
export default class ResidentialMarketList extends Component {

	/**
	 * @param {object} props
	 */
	constructor(props) {
		super(props)
	}

	/**
	 * @returns {Array}
	 */
	getFilteredResidentialAreas() {
		const residentialAreaIdentifiers = []
		this.props.currentCallForApplication.callForApplicationItems.map(callForApplicationItem => {
			const residentialAreaIdentifier = parseInt(callForApplicationItem.realEstateObject.residentialArea)
			if (!residentialAreaIdentifiers.includes(residentialAreaIdentifier)) {
				residentialAreaIdentifiers.push(residentialAreaIdentifier)
			}
		})

		// const validResidentialArea = []
		const filteredResidentialAreas = []
		this.props.residentialAreas.map(residentialArea => {
			if (residentialAreaIdentifiers.includes(residentialArea.residentialAreaIdentifier)) {
				filteredResidentialAreas.push({
					value: residentialArea.residentialAreaIdentifier,
					text: residentialArea.title
				})
			}
		})

		return _.sortBy(filteredResidentialAreas, 'text')
	}

	/**
	 * @returns {JSX.Element}
	 */
	render() {
		const {t} = this.props;

		return (
			<div id="callForApplicationItems__filter" className="callForApplicationItems__filter">
				<div className="row">
					<div className="col-12 col-md-6">
						<select className="form-control c-select"
								value={this.props.filterRoom}
								onChange={this.props.handleFilterRoomChange}>
							<option value="">Alle Wohnungsgrössen</option>
							<option value="1-2.5">1-2.5 Zimmer</option>
							<option value="3-4.5">3-4.5 Zimmer</option>
							<option value="5-100">5 und mehr Zimmer</option>
						</select>
					</div>
					{
						(AblCh.showForResidentialArea === 0 && !AblCh.callForApplicationIdentifier) &&
						<div className="col-12 col-md-6">
							<select className="form-control c-select"
									value={this.props.filterResidentialArea}
									onChange={this.props.handleFilterResidentialAreaChange}>
								<option value="">Alle Siedlungen</option>
								{this.getFilteredResidentialAreas().map(residentialArea => {
									return (
										<option value={residentialArea.value} key={residentialArea.value}>
											{residentialArea.text}
										</option>
									)
								})}
							</select>
						</div>
					}
				</div>
				<small>
					{this.props.filteredCallForApplicationItems.length}
					&nbsp;
					{this.props.filteredCallForApplicationItems.length > 1 ? 'Wohnungen' : 'Wohnung'} gefunden.
				</small>
			</div>
		)
	}
}
